// extracted by mini-css-extract-plugin
export default {"dropdown":"ArtistDetails_dropdown__0+ajP"};